import { COMMENT_TRUNCATE_LEN_LONG, truncateString } from '@/helpers';
import { MediaCommentedMessage } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import Card, { CardProps } from './Card';
import { CardHabitatLink } from './CardLink';
import { getMediaQueryParams } from './utils';

const MediaCommentCreatedCard = ({ messageWithMeta }: CardProps<MediaCommentedMessage>) => {
  const { message } = messageWithMeta;
  const mediaType = 'media' in message ? message.media.type : message.mediaType;
  return (
    <Card messageWithMeta={messageWithMeta}>
      <p className="preflight preflight-p line-clamp-3">
        commented &quot;
        <CardHabitatLink
          message={message}
          query={getMediaQueryParams(message)}
          onClick={() => {
            trackMP('community-feed-clicked', {
              content: 'comment',
            });
          }}
        >
          {truncateString(message.comment.text, COMMENT_TRUNCATE_LEN_LONG)}
        </CardHabitatLink>
        &quot; on a {mediaType === 'video' ? 'clip' : 'photo'} of the{' '}
        <CardHabitatLink
          message={message}
          onClick={() => {
            trackMP('community-feed-clicked', {
              content: 'habitat',
            });
          }}
        >
          {message.habitat.title}
        </CardHabitatLink>
      </p>
    </Card>
  );
};

export default MediaCommentCreatedCard;
